import { Component, OnInit, input } from '@angular/core';
import { AdminReadyRequestDetail, PayoutRequestStatus, ThkeeCommonModule } from 'thkee-common';
import { AvatarComponent } from '../../../../../../../../thkee-common/src/lib/components/avatar/avatar.component';
import { CurrencyPipe, DatePipe } from '@angular/common';

@Component({
    selector: 'app-ready-request-detail',
    templateUrl: './ready-request-detail.component.html',
    styleUrls: ['./ready-request-detail.component.scss'],
    imports: [AvatarComponent, CurrencyPipe, DatePipe, ThkeeCommonModule]
})
export class ReadyRequestDetailComponent implements OnInit {
  readonly request = input.required<AdminReadyRequestDetail>();
  actionTitles: Record<PayoutRequestStatus, string> = {
    requested: 'Created by',
    ready: 'Approved by',
    deactivated: 'Deactivated by',
    processing: 'Processing by',
    failed: 'Fail',
    paid: 'Paid by',
  }

  constructor() { }

  ngOnInit(): void {
  }

}
